// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1fi-F","select":"Header_select__-vmRD","clinic":"Header_clinic__MD-x_"};